import NumberInput from './number-input.vue'
export type { NumberInputProps } from './props'
export default NumberInput